export class EnumConverterHelpher {
    static EnumConverter(obj: any) {
        return Object.entries(obj).map(([label, value]: any) => ({ label, value }));
    }
}